import { FunctionComponent, ReactElement, ReactNode, createContext, useState } from 'react';

type Errors = Record<string, string[]>;
type ErrorsRegistry = Record<string, Errors>;

export interface IErrorsContext {
	add: (formKey: string, errors: Errors) => void;
	clear: (formKey: keyof ErrorsRegistry) => void;
	get: (formKey: keyof ErrorsRegistry) => Errors;
}

export const ErrorsContext = createContext<IErrorsContext>({
	add: () => {},
	clear: () => {},
	get: () => ({}),
});

export const ErrorsProvider: FunctionComponent<{ children: ReactNode }> = ({
	children,
}): ReactElement => {
	const [errors, setErrors] = useState<ErrorsRegistry>({});

	const add = (formKey: string, formErrors: Errors) =>
		setErrors({ ...errors, [formKey]: formErrors });

	const clear = (formKey: keyof ErrorsRegistry) => {
		const errorsRegistryCopy = { ...errors };
		delete errorsRegistryCopy[formKey];
		setErrors(errorsRegistryCopy);
	};

	const get = (formKey: string) => errors[formKey];

	return <ErrorsContext.Provider value={{ add, clear, get }}>{children}</ErrorsContext.Provider>;
};
